import { Button } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import React from "react";
import { To } from "react-router-dom";
import { useRouterLinkProps } from "../hooks/useRouterLinkProps";

const useStyles = createStyles({
  backLink: {
    alignSelf: "flex-start",
    paddingInlineStart: 0,
  },
});

export interface BackLinkProps {
  to: To;
  children: React.ReactNode;
  "data-testid"?: string;
}

/**
 * Codex "Button Brand Text L" idiom for returning to a parent list view.
 * Renders an anchor so middle-click and copy-link work natively, while
 * still performing client-side navigation. Self-aligns to the start of the
 * cross-axis and drops the button's leading padding so the chevron lines
 * up with the heading below it.
 */
export const BackLink: React.FC<BackLinkProps> = ({ to, children, ...rest }) => {
  const { href, onClick } = useRouterLinkProps(to);
  const { classes } = useStyles();
  return (
    <Button
      as="a"
      href={href}
      onClick={onClick}
      variant="text"
      intent="primary"
      size="large"
      iconLeft={<IconV3 icon="chevron_left" size={20} color="inherit" />}
      className={classes.backLink}
      {...rest}
    >
      {children}
    </Button>
  );
};
